import { Component, inject, OnInit } from '@angular/core';
import { CartService } from '../../../core/services/cart/cart.service';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatRadioButton } from '@angular/material/radio';
import { MatIcon, MatIconModule } from '@angular/material/icon'; 
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ProductViewVm } from '../../../core/models/product-view';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatRadioButton, MatIcon, MatTableModule, MatButtonModule,MatTooltipModule],
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  router = inject(Router);
  private route = inject(ActivatedRoute);
  public products: any[];
  public grandTotal!: number;
  countryIsoCode: any;
  showDialog: boolean = false;
  displayedColumns: string[] = ['sNo', 'itemSKU','productName', 'productImage', 'countryName',  'price', 'action'];
  data: MatTableDataSource<ProductViewVm> = new MatTableDataSource<ProductViewVm>();

  constructor(private cartService: CartService) { }

  ngOnInit(): void {
    /* this.route.queryParams.subscribe(params => {
      this.countryIsoCode = params['country'] || null;
    }); */
  
    this.cartService.getProducts().subscribe(res => {
      this.products = res;
      this.data.data = this.products;
    });
  }
  
  removeItem(item: any): void {
    this.cartService.removeCartItem(item);
    this.products = this.products.filter(product => product !== item);
    this.data.data = this.products;
  }
  emptycart(): void {
    this.cartService.removeAllCart();
    this.products = [];
    this.data.data = [];
  }

   view(): void {
     this.router.navigateByUrl('catalogue-view');
   } 
  
 
  closeDialog(): void {
    this.showDialog = false;
  }

  checkoutDialog(): void {
    this.showDialog = true;
  }
  radioButtonClick(buttonType:string){
    if(buttonType === 'excel'){
      this.router.navigate(['excel-upload'], {
        queryParams: { country: this.countryIsoCode }
      });
    }
    else  if(buttonType === 'form'){
      this.router.navigate(['web-form'], {
        queryParams: { country: this.countryIsoCode }
      });
    }
    else{
      this.showDialog = false;
    }
  }
  

  
}
